var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7266_41409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0V12L3.51468 20.4853C5.68626 22.6568 8.68626 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37262 12 0 12 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C8.68626 0 5.68626 1.34316 3.51468 3.51469C6.4589 6.45891 7.50407 7.50412 12 12H24C24 5.37262 18.6274 0 12 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21677 12L6.75127 11.3107L7.53169 9.89132L5.94028 10.1958L5.73863 8.5881L4.63013 9.77048L3.52167 8.5881L3.31997 10.1958L1.72861 9.89128L2.50903 11.3107L1.04349 12L2.50903 12.6893L1.72861 14.1087L3.32011 13.8043L3.52163 15.4119L4.63013 14.2295L5.73863 15.4119L5.94028 13.8043L7.5316 14.1087L6.75122 12.6894L8.21677 12Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2003 4.69565L3.68799 5.37735L4.48697 5.12427L3.98925 5.79871L4.47694 6.48041L3.68166 6.21552L3.18399 6.88991L3.19022 6.05179L2.39499 5.78685L3.19411 5.53377L3.2003 4.69565Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2003 17.1101L3.68799 17.7918L4.48697 17.5387L3.98925 18.2131L4.47694 18.8948L3.68166 18.63L3.18399 19.3043L3.19022 18.4662L2.39499 18.2013L3.19411 17.9482L3.2003 17.1101Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1562 10.9029L9.66857 11.5846L8.86954 11.3314L9.36726 12.0059L8.87957 12.6877L9.67485 12.4227L10.1726 13.0971L10.1663 12.259L10.9615 11.9941L10.1624 11.741L10.1562 10.9029Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7266_41409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/ph.7b8b84c1aeded3a295fbf69bf22dd636.svg";
export { ForwardRef as ReactComponent };